import { defineCustomElement } from 'vue'
import { createPinia } from 'pinia'
import { configuration, dataLayer, privacy, config, authentication, api, hybrid } from '@dpgradio/creative'
import '@dpgradio/creative/styles/fonts/qmusic.css'
import MattieVsMarieke from './MattieVsMarieke.ce.vue'

function isStaging() {
  const { buildName } = hybrid.appInfo()
  const queryStaging = new URLSearchParams(window.location.search).has('staging')
  return queryStaging || (buildName || '').endsWith('test')
}

const initialize = async () => {
  authentication.initialize()

  try {
    await configuration.retrieveConfigForStation('qmusic_nl')
  } catch (error) {
    console.error('Could not load configuration.', error)
  }

  if (isStaging()) {
    api.baseUrlOverride = api.baseUrl.replace('api.', 'api.stag.')
  }

  const language = config('language')
  if (language) {
    document.documentElement.lang = language
  }

  const pinia = createPinia()

  const MattieVsMariekeElement = defineCustomElement(MattieVsMarieke, {
    configureApp: (app) => {
      app.use(pinia)
    },
  })

  customElements.define('mattie-vs-marieke', MattieVsMariekeElement)

  privacy.initialize()
  dataLayer.initialize()
  dataLayer.pushVirtualPageView()
}

initialize()
